// SMCR Directory: the route and the sidebar row of `wealth.compliance.smcr` (ADR-0027).
//
// The page is an empty state: no source fills the directory yet. Dowgate staff
// see it today, so the Dowgate manifest turns the feature on.
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.smcr',
    routes: [
        {
            frontend: 'comply',
            path: 'smcr-directory',
            lazy: () => import('@/pages/comply/smcr-directory/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'smcr-directory',
            label: 'SMCR Directory',
            href: '/comply/smcr-directory',
            icon: 'UserCheck',
            group: 'governance',
            order: 1070,
            wip: true,
        },
    ],
});
